import { render } from "./SerieItem.vue?vue&type=template&id=cdeef1a4"
import script from "./SerieItem.vue?vue&type=script&lang=js"
export * from "./SerieItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__